<template>
   <el-dialog :title="params.title" ref="dialogssRef"
     :visible.sync="params.dialogVisible" :append-to-body="params.isAppendToBody"
     custom-class="subDialog"  :width="params.width"  @close="()=>{params.close ? params.close() : ''}"
     :close-on-click-modal="false"
     :destroy-on-close="true">
     <div v-if="params.isComponebt">
        <!-- 动态组件 -->
        <!-- <keep-alive> -->
            <component  v-bind:is="params.component" :params="params.data"></component>
        <!-- </keep-alive> -->
     </div>
     <div v-else>
        <!-- 详情  编辑  提交？  isShow:false是显示   true是隐藏 -->
        <el-form   :model="ruleForm" :rules="rules" ref="ruleForm" 
            :label-width="params.labelWidth || '100px'" class="demo-ruleForm" 
            :disabled="params.isDisabled"
            >
        <!-- <el-form-item v-if="!item.isShow"  :label="$utils.labelByValue_global(item)" :prop="item.filed"  :label-width="item.labelWidth || '100px'" 
            v-for="(item,index) in params.labelList" :key="index">
                <inputRuleCon :params="item" :ruleForm="ruleForm"></inputRuleCon>
        </el-form-item> -->
        <div :class="isInline ? 'formItemWrap' : ''">
            <div  v-for="(item,index) in params.labelList" :class="isInline ? 'itemDicv' : ''">
                <div v-if="!item.isShow" >
                    <div v-if="!item.isLabelCustom">
                        <el-form-item  :label="$utils.labelByValue_global(item)" :prop="item.filed"  :label-width="isInline ? '120px' : ( item.labelWidth || '100px') " 
                        :key="index">
                                <inputRuleCon :params="item" :ruleForm="ruleForm"></inputRuleCon>
                        </el-form-item>
                    </div>
                    <div v-else class="labelStyle">
                        <el-form-item  :label="$utils.labelByValue_global(item)" :prop="item.filed"  :label-width="isInline ?  '120px': ( item.labelWidth || '100px')" 
                        :key="index">
                                <inputRuleCon :params="item" :ruleForm="ruleForm"></inputRuleCon>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>
        <el-form-item v-if="params.isBtn">
            <!-- <el-button type="primary" @click="submitForm('ruleForm')">{{ params.submitText || '提交' }}</el-button> -->
            <el-button type="primary" @click="$utils.debounce(submitForm,500)">{{ params.submitText || '提交' }}</el-button>
            <!-- 特殊页面 =》 特殊按钮/ -->
            <el-button  v-if="params.otherBtn " type="primary" @click="$utils.debounce(submitFormOther,500)">{{params.otherBtn}}</el-button>
            <el-button v-if="!params.isResetbtn" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
        </el-form>
     </div>
</el-dialog>
</template>

<script>
  import inputRuleCon from '@/components/inputRule'
    export default {
        components: {
            inputRuleCon
        },
        props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
        data() {
            return {
                ruleForm:{},
                rules: {
                    // name: [
                    // { required: true, message: '请输入商品名称', trigger: 'blur' },
                    // // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    // ]
                },
                isInline:false,
            }
        },
        computed: {
        },
        watch:{
            'params.isChangeFiled':{
                handler:function(val,oldVal){
                    // this.ruleForm = this.$utils.getWatchRule(this.params.labelList,this.ruleForm);
                    if(val){
                        let valFiled = val.split(",")[1];
                        this.ruleForm[valFiled] = "";
                    }
                    console.log("=============params.isChangeFiled",val,oldVal,this.ruleForm,this.params)
                },
                // deep: true
            },
            //更改赋值  监听
            'params.labelList':{
                handler:function(val,oldVal){
                    // this.ruleForm = this.$utils.getWatchRule(this.params.labelList,this.ruleForm);
                    if(!this.params.isWatchLabelList){ return }
                    if(val){
                        let list= val;
                        //type : 1 待验证的input框
                        if(this.params.isRequired){
                            // this.ruleForm = this.$utils.getRule(this.params.labelList);
                            this.ruleForm ={...this.ruleForm,...this.$utils.getWatchRule(list)} ;
                            for(let item of list){
                                if(item.isRequired){
                                    let arr = [];
                                    arr.push(
                                        {required:true,message:item.placeholder,trigger:'blur'}
                                    )
                                    this.rules[item.filed] = arr;
                                }
                            }
                        }else{
                            if(!this.params.isComponebt){
                                // this.ruleForm = this.$utils.getRule(this.params.labelList);
                                this.ruleForm ={...this.ruleForm,...this.$utils.getWatchRule(list)} ;
                            }
                        }
                    }
                    console.log("params.labelList,params.labelList",val,oldVal,this.ruleForm,this.params)
                },
                deep: true,
                immediate:true
            }
        },
        destroyed () {
            this.$off();
            // debugger
            // this.$refs.refCom1.$destroy();
            // this.$refs.ruleForm.$destroy();
        },
        created () {
            console.log("[[[[[[[[[[[[]]]]]]]]]]]]",this.params)
            let list= this.params.labelList || [];
            // this.isInline = this.params.isInline && (list.length() > 12 ? true : false)
            this.isInline = list.length > 12 ? true : false
            //type : 1 待验证的input框
            if(this.params.isRequired){
                this.ruleForm = this.$utils.getRule(list);
                for(let item of list){
                    if(item.isRequired){
                        let arr = [];
                        arr.push(
                            {required:true,message:item.placeholder,trigger:'blur'}
                        )
                        this.rules[item.filed] = arr;
                    }
                }
                
            }else{
                if(!this.params.isComponebt){
                    this.ruleForm = this.$utils.getRule(this.params.labelList);
                }
            }
        },
        beforeUpdate () {
            console.log("数据编号",this.ruleForm,this.$refs.dialogssRef)
        },
        methods: {
            // submitForm(formName) {
            submitForm() {
                let that = this;
                that.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    console.log("submit",that.ruleForm)
                    that.$emit("listenDialog",{type:that.params.type,data:that.ruleForm})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            //特殊处理  Form表单
            submitFormOther() {
                let that = this;
                that.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    console.log("submit",that.ruleForm)
                    that.$emit("listenDialog",{type:'999',btnText:that.params.otherBtn,data:that.ruleForm})
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                for(let key in this.ruleForm){
                    this.ruleForm[key] = this.ruleForm[key] || "";
                }
                //重置图片列表
                for(let item of this.params.labelList){
                    if(item.inputType == 'upload'){
                        item.fileList = [];
                         item.value = "";
                    }else if(item.inputType == 'editor'){
                        item.value = "";
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .labelStyle{
        /deep/ .el-form-item__label{
            font-weight:bold;
            color:red;
        }
    }
  /deep/ .el-form-item{
    margin-bottom: 10px !important;
  }
  .formItemWrap{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .itemDicv{
        width: 46%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/dialog/index.vue